"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const FormButton_1 = require("./FormButton");
const FormFields_1 = require("./FormFields");
function FormWrapper({ children, submitButton, form, formikProps, errorAlert, loader, successNotification, FormButtonComponent, }) {
    const formFields = jsx_runtime_1.jsx(FormFields_1.FormFields, Object.assign({ formikProps: formikProps }, { children: children }), void 0);
    let submit = undefined;
    if (submitButton) {
        const submitFormButtonProps = {
            children: submitButton,
            disabled: formikProps.isSubmitting,
            Component: FormButtonComponent,
        };
        submit = FormButton_1.useSubmitFormButton(submitFormButtonProps);
    }
    return (jsx_runtime_1.jsxs(formik_1.Form, Object.assign({}, form, { children: [errorAlert, loader, successNotification, formFields, submit] }), void 0));
}
exports.FormWrapper = FormWrapper;
//# sourceMappingURL=FormWrapper.js.map